export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEENzgtSGEFISIBvU8NAb1RCQK9UwIEvVYEEb1bQRUhYb1thT8AAQABAAEAAQAZAB8AAQABAAYAgTIAAQABAAEAAQAZAB8AAQABAAYAYQEldQG+Ag==", "base64")


//////////////////
// WEBPACK FOOTER
// ./src/components/vue-pdf/src/buffer-loader.js!./node_modules/pdfjs-dist/cmaps/78-V.bcmap
// module id = FCZd
// module chunks = 0